import { TProductGalleryDuoVariants, TProductGalleryQuartetVariants, TProductGallerySingleVariants, TProductGalleryTrioVariants } from '@features/cms/typescript';
import reusables from '@styles/theme/reusables';
import getInspirationImageSize from '@utils/getInspirationImageSize';
export default {
  imageDuoBox: (variant: TProductGallerySingleVariants | TProductGalleryDuoVariants | TProductGalleryTrioVariants | TProductGalleryQuartetVariants) => ({
    position: 'relative',
    width: getInspirationImageSize(variant).width,
    height: getInspirationImageSize(variant).height,
    border: 'none',
    background: 'transparent',
    '.image_hover': {
      objectFit: 'cover',
      opacity: 0,
      ...reusables.mainTransition('opacity')
    },
    '&:hover .image_hover': {
      opacity: [0, 0, 0, 1]
    }
  })
};